import * as React from "react";
import { Input } from "components";
import moment from "moment";

const CustomInput: React.FC<any> = ({ ref, ...props }) => (
  <Input
    {...props}
    autoComplete="off"
    name={props.field}
    innerRef={ref as React.Ref<HTMLInputElement>}
    onChange={({ event }) => props?.onChange(event)}
    value={props.value ? moment(props.value).format("MMMM D, YYYY") : undefined}
  />
);

export default CustomInput;
